import { AutorizacionUsuario } from './AutorizacionAction';

//Servicios 
import httpClientePublicoLogin from '../../Servicios/httpClientePublicoLogin';
import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';
import httpClientePublicoCore from '../../Servicios/httpClientePublicoCore';
import httpClientePublicoSeguridad from '../../Servicios/HttpClientePublicoSeguridad';
import httpClienteSeguridad from '../../Servicios/HttpClienteSeguroSeguridad';


//// Se encacarga de recuperar los datos d un usuario
//export const obtenerDatosRecuperacionUsuario = (Emailx) => {
//    return new Promise((resolve, reject) => {
//        httpClientePublicoCore.post('/Usuario/UserRecorery/', { Email: Emailx }).then(response => {
//            resolve(response);
//        }).catch(error => {
//            resolve(error.response);
//        });
//    });
//};


// Se encacarga de establecer el idioma de un usuario
export const EstableceIdiomaUsuario = (userId, codLanguaje) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Usuario/SetLanguage/', { UserId: userId, CodLanguaje: codLanguaje }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de contar el numero de accesos de un usuario a un modulo
export const ContabilizarAccesoModuloUsuario = (userId, companyId, moduleId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Usuario/AccessCount/', { UserId: userId, CompanyId: companyId, ModuleId: moduleId }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de contar el numero de accesos de un usuario a una opcion
export const ContabilizarAccesoItemModuloUsuario = (userId, companyId, subItemId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Usuario/AccessOptionCount/', { UserId: userId, CompanyId: companyId, SubItemId: subItemId }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se usa para obtener listado de compa�ias un cliente por su id
export const obtenerListaCompaniasUsuario = (UserId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/Usuario/UserCompanies/" + UserId).then(response => {
                resolve(response);

            })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// metodo que consume al service  y consume el endpoint para obtener el usuario actual 
export const obtenerUsuarioActual = (idioma, dispatch) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/Usuario").then(response => {

            if (response.data && response.data.imagenPerfil)  // se rrevisa al obtener el usuario la representacion de la foto para pintarla en la carga 
            {
                let fotoPerfil = response.data.imagenPerfil;
                const nuevoFile = fotoPerfil.data;//'data:image/' + fotoPerfil.extension + ';base64,' + fotoPerfil.data;
                response.data.imagenPerfil = nuevoFile;
            } 

            const comId = window.localStorage.getItem("selected_company");
            let user = response.data;
            if (comId !== null) {
                user = {
                    userId: response.data["userId"],
                    nombreCompleto: response.data["nombreCompleto"],
                    email: response.data["email"],
                    username: response.data["userName"],
                    imagenPerfil: response.data["imagenPerfil"],
                    defaultLanguage: response.data["defaultLanguage"],
                    companyId: comId
                }
                response.data.companyId = comId;
            }

            // llamada al reducer
            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true
            });

            // Se llama al metodo de autorizacion 
            AutorizacionUsuario(user.companyId, "11111111-1111-1111-1111-111111111111", user.userId, idioma, dispatch);

            resolve(response);
        }).catch((error) => {
            resolve(error);
        });
    });
};

// Metodo del action que consume el service y permite el proceso de Logueo
export const loginUsuario = (usuario, dispatch) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoLogin.post("/Login", usuario).then(response => {
            // se graba en el local storage el token del proceso de login para el uso de futuros request
            window.localStorage.setItem("token_seguridad", response.data.token);

            if (response.data && response.data.imagenPerfil)  // se rrevisa al obtener el usuario la representacion de la foto para pintarla en la carga 
            {
                let fotoPerfil = response.data.imagenPerfil;
                const nuevoFile = fotoPerfil.data;//'data:image/' + fotoPerfil.extension + ';base64,' + fotoPerfil.data;
                response.data.imagenPerfil = nuevoFile;
            } 

            // se escribre en el store a la variable de sesion 

            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true
            });

            window.localStorage.setItem("selected_company", response.data["companyId"]);

            resolve(response);
        }).catch(error => {
            console.log(error.response);
            resolve(error.response);

        });
    });

};


// Metodo del action que consume el service y permite el proceso de Logueo por medio de Azure Active Directory 
//Basado en el correo como cuenta contra el api de login interno con el Entity Core y el api Login 
export const loginUsuarioAAD = (usuario, dispatch) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoLogin.post("/Login/LoginADD", usuario).then(response => {
            // se graba en el local storage el token del proceso de login para el uso de futuros request
            window.localStorage.setItem("token_seguridad", response.data.token);

            if (response.data && response.data.imagenPerfil)  // se rrevisa al obtener el usuario la representacion de la foto para pintarla en la carga 
            {
                let fotoPerfil = response.data.imagenPerfil;
                const nuevoFile = fotoPerfil.data;//'data:image/' + fotoPerfil.extension + ';base64,' + fotoPerfil.data;
                response.data.imagenPerfil = nuevoFile;
            }

            // se escribre en el store a la variable de sesion 

            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true,
                tipoLogueo: 'SSO'
            });

            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true,
                tipoLogueo: 'SSO'
            });

            window.localStorage.setItem("selected_company", response.data["companyId"]);

            resolve(response);
        }).catch(error => {
            console.log(error.response);
            resolve(error.response);

        });
    });

};

//auditoria login
export const auditoriaLogin = (data) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoLogin.post("/Login/LoginLog", data).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export const obtenerImagenPerfil = (IdUsuario) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/UsuarioImagen/" + IdUsuario).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

//guardar o actualiza imagen usuario sistema
export const guardarImagenUsuario = (dataImagen) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post("/UsuarioImagen/GuardarImagen/", dataImagen).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se encacarga realizar log cierre sesion
export const registroCierreSesion = (userId, automatico) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/Usuario/LogOutLog/', { UserId: userId, Automatic: automatico }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de validez token cambio contrase�a
export const validaTokenCambioContrasena = (idToken) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/Usuario/ValidaTokenPassword/', { IdControl: idToken }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de desactivar token cambio contrase�a luego de usarlo
export const desactivaTokenCambioContrasena = (idToken) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/Usuario/DesactivaTokenPassword/', { IdControl: idToken }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de validez token cambio contrase�a
export const realizaCambioContrasena = (userId, password, confirmacionPassword) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/Usuario/CambiarContrasena/', { UserId: userId, Password: password, ConfirmacionPassword: confirmacionPassword }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


// Se encacarga de validez token cambio contrase�a
export const solicitarCambioContrasena = (email, recoveryURL) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoSeguridad.post('/SolicitudCambioClave/LoginUsuario/', { Email: email, RecoveryURL: recoveryURL }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


/**
 * obtener texto seguro 
 * @param {{ userId:string, 
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} objRequest
 * @returns {Promise<{data:{ id:string, email:string fullName:string, accessClassStore:boolean }, status:number, statusText:string}>}
 */
export const obtenerAccesoClassStore = (objRequest) => {

    return new Promise((resolve, reject) => {
        httpClienteSeguridad.post('/Usuario/Obtener', objRequest).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });

};